<button [class]="clasStyle" (click)="onClickButton()">{{text}}</button>
